<life-di-nav></life-di-nav>
<lifedi-breadcrumb></lifedi-breadcrumb>

<div class="container text-center" style="padding-top: 30px;">
  <h1 class="lifedi-color">
    รายการทางการเงิน
  </h1>

  <!-- teacher screen -->
  <div class="row d-flex justify-content-center" *ngIf="role === 'teacher'">
    <div class="col-lg-4 col-md-4 col-sm-6 col-xs-1" *ngFor="let i of financialTeacherList">
      <lifedi-icon-home [imageUrl]="i.imgUrl" [title]="i.title" [link]="i.link"></lifedi-icon-home>
    </div>
  </div>

  <!-- psychologist screen -->
  <div class="row d-flex justify-content-center" *ngIf="role === 'psychologist'">
    <div class="col-lg-4 col-md-4 col-sm-6 col-xs-1" *ngFor="let p of financialPsychoList">
      <lifedi-icon-home [imageUrl]="p.imgUrl" [title]="p.title" [link]="p.link"></lifedi-icon-home>
    </div>
  </div>
</div>
